export interface PromoPriceSource {
  wellKnownAttributes?: { Price?: number }
  promoPrice?: null | number
  hasCartPromo?: boolean
}

export function getBasePrice(item: PromoPriceSource): number {
  return item.wellKnownAttributes?.Price ?? 0
}

export function getCatalogPromoPrice(item: PromoPriceSource): number | null {
  return item.promoPrice ?? null
}

export function hasVisualDiscount(
  basePrice: number,
  promoPrice: number | null | undefined,
): boolean {
  return promoPrice != null && promoPrice < basePrice
}

export function getEffectiveCatalogPrice(item: PromoPriceSource): number {
  const base = getBasePrice(item)
  const promo = getCatalogPromoPrice(item)
  return hasVisualDiscount(base, promo) ? promo! : base
}

export function hasCartPromoOnly(item: PromoPriceSource): boolean {
  return Boolean(item.hasCartPromo) && !hasVisualDiscount(
    getBasePrice(item),
    getCatalogPromoPrice(item),
  )
}
